import Chart, {useChart} from 'src/components/chart';

// ----------------------------------------------------------------------

type Props = {
  chartRef?: any;
  series: {
    name: string;
    data: number[];
  }[];
  chartOptionsObj?: any;
  type?: any;
};

export default function ChartLine({ chartRef, series, chartOptionsObj, type}: Props) {
  const chartOptions = useChart({
    xaxis: {
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep'
      ]
    },
    tooltip: {
      x: {
        show: false
      },
      marker: {show: false}
    },
    ...chartOptionsObj
  });

  return (
    <Chart
      ref={chartRef}
      dir="ltr"
      type={type ?? 'line'}
      series={series}
      options={chartOptions}
      width="100%"
      height={320}
    />
  );
}
